import Mutations from '../../odata/mutations';

export default { ...new Mutations('mfcDefault'), ...new Mutations('mfcDefaults') };
